<template>
  <div class="text-center">
    <h3 class="mt-2 text-sm font-medium text-slate-900">
      No items yet
    </h3>
    <template v-if="link">
      <p class="mt-1 text-sm text-slate-500">
        Get started by adding a new one.
      </p>
      <div class="mt-6">
        <router-link :to="link" class="btn-primary">
          <PlusCircleIcon class="-ml-1 mr-2 h-4 w-4" aria-hidden="true" />
          Add new item
        </router-link>
      </div>
    </template>
  </div>
</template>

<script setup>
import { PlusCircleIcon } from '@heroicons/vue/24/outline';

defineProps({
  link: {
    type: String,
    default: null
  }
});
</script>
